import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {DjPsycho} from "../DjPsycho";
import {TimelineLite} from "gsap";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {DjPsychoSound} from "../sound/DjPsychoSound";

export class DjPsychoNoWinView extends PIXI.Container implements StageLayer {
    private readonly _noWin: PIXI.spine.Spine;
    private NO_WIN_ANIMATION_NAMES: string[] = ["No_Win_1", "No_Win_2", "No_Win_3"];
    private _soundName: string;

    constructor() {
        super();
        this.name = "DjPsychoNoWinView";

        this._noWin = new PIXI.spine.Spine(DjPsycho.assetLoader.getSpineAsset("fsBadOutro"));
        this._noWin.visible = false;
        this._noWin.position.set(360);
        this.addChild(this._noWin);
    }

    public showNoWin(): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            idx: number = MathHelper.randomNumberInRange(0, 2),
            animName: string = this.NO_WIN_ANIMATION_NAMES[idx];

        this._soundName = DjPsychoSound.NO_WIN_SCREENS[idx];

        tl.add([
            () => {
                // #170
                DjPsycho.soundPlayer.playSound(this._soundName);

                this._noWin.visible = true;
            },
            DjPsycho.createTimelineForAnimation(this._noWin, 0, animName, false)
        ]);
        tl.add(() => {
            this._noWin.visible = false;
        });
        return tl;
    }

    // #170
    public skip(): void {
        if (this._soundName) {
            DjPsycho.soundPlayer.fadeOutEffect({
                name: this._soundName,
                duration: 200,
                to: 0
            });
        }
    }
}
